export const membershipFaqs = [
  {
    question: 'What are the fees of Marathi Vadhu Var Suchak?',
    answer:
      'By paying just Rs 2000/- with multiple online payment options and getting more access for premium features online chatting, call directly and get instant contact details like mobile number and email ID etc.',
  },
  {
    question: 'Is Marathi Vadhu Var Suchak matrimony free?',
    answer:
      'Yes! Marathi Vadhu Var can register for free. But with a paid subscription plan Marathi brides and grooms can chat online including direct Messaging with instant contact details.',
  },
  {
    question: 'Can I make payment through the Marathi Vadhu Var Suchak mobile app?',
    answer: 'Yes! Marathi Vadhu Var Suchak mobile app has provision for online paid subscription plan.',
  },
  {
    question: 'Which is the best free Maratha Matrimony site?',
    answer: 'Marathi Vadhu Var Suchak is the best Marathi Matrimony site for Maratha community Vadhu Var for free registration.',
  },
  {
    question: 'What happens after my membership expires?',
    answer:
      "After expiration, you'll lose access to premium features but can still view basic profiles. You can renew anytime to regain full access.",
  },
  {
    question: 'Can I upgrade from 1-year to 3-year plan?',
    answer: "Yes! You can upgrade anytime. We'll calculate the pro-rated amount and apply it to your new plan.",
  },
  {
    question: 'Is the membership refundable?',
    answer:
      'We appreciate your interest in our services. Please note that our membership plans are non-refundable. We encourage you to carefully review our features and terms before making your purchase decision. If you have any questions about our services, please feel free to contact our support team.',
  },
  {
    question: 'Do I get access to all features immediately?',
    answer: 'Yes! All premium features are activated immediately after successful payment confirmation.',
  },
  {
    question: 'Can I share my membership with family members?',
    answer: 'Membership is personal and tied to your account. However, you can help family members create their own profiles.',
  },
  {
    question: 'Do you accept any kind of payment other than the above premium membership?',
    answer:
      "Please note, we do not accept any type of payment online or offline other than the above premium membership payment, nor do we request it. Likewise, no third party has been appointed by us to accept or request premium membership payments, and we do not grant franchising to anyone. We will not be responsible for any other incorrect money transactions apart from users' premium membership payments.",
  },
];

